<form class="column gap" [formGroup]="userForm">
  <mat-toolbar class="center modal__toolbar">
    <div class="row gap">
      <h5 class="top-bar-view-title full-width">{{ 'ChangeRolesComponent.title' | translate }}</h5>
      <span class="fill-remaining-space"></span>
    </div>
    <span class="fill-remaining-space"></span>
  </mat-toolbar>
  <div class="column gap-lg modal__inputs">
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'ChangeRolesComponent.email' | translate }}
      </mat-label>
      <input [disabled]="true" matInput placeholder="Search users" type="text" formControlName="email" />
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label>{{ 'ChangeRolesComponent.text' | translate }}</mat-label>
      <mat-select [disabled]="true" formControlName="roles" multiple>
        <mat-option *ngFor="let role of roles" [value]="role">{{ displayRoles[role] }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="row horizontal-end">
      <button class="modal__button" mat-raised-button color="primary" [disabled]="userForm.invalid" (click)="changeRoles()">
        {{ 'ChangeRolesComponent.buttonText' | translate }}
      </button>
    </div>
  </div>
</form>
